// src/frontend/Adviser/HelperFunctions/generateStyledEmailTemplate.js

export const generateStyledEmailTemplate = (content) => {
  const timestamp = new Date().toISOString();
  const greeting = `Good ${
    timestamp.split("T")[1].split(":")[0] >= 12 ? "afternoon" : "morning"
  },`;
  return `
  <!DOCTYPE html>
  <html>
  <head>
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #081e56;
        color: white;
      }
      .greeting {
        font-size: 16px;
        font-weight: bold;
      }
      .message {
        margin-bottom: 15px;
      }
      p {
        font-family: Arial, sans-serif;
        font-size: 14px;
      }
    </style>
  </head>
  <body>
  ${greeting}
   <p>I hope this email finds you well.</p>
    ${content}
  </body>
  </html>
  `;
};
